import { render } from "./imgSet.vue?vue&type=template&id=6dd4df0e&scoped=true"
import script from "./imgSet.vue?vue&type=script&lang=js"
export * from "./imgSet.vue?vue&type=script&lang=js"

import "./imgSet.vue?vue&type=style&index=0&id=6dd4df0e&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd4df0e"]])

export default __exports__